import React from 'react';
import './SearchKittBar.css';

/** Thin LED scanner while search/fetch is in flight (Feed KITT pattern; SRCH-01/02). */
const SearchKittBar = ({ active, label = 'Loading results' }) => (
  <div
    className={`search-kitt-bar${active ? ' search-kitt-bar--active' : ''}`}
    role="progressbar"
    aria-hidden={!active}
    aria-label={active ? label : undefined}
  >
    <span className="search-kitt-scan" aria-hidden="true" />
  </div>
);

export default SearchKittBar;
